import {INavigableValidatableModel} from "~/interfaces/navigableValidationInterfaces";
import NavigableValidator, {INavigableValidatorOptions} from "./navigableValidator"
import {ValidationResultValueInterface} from "~/interfaces/validationResultInterface";
import {ValidationErrorMessage} from "~/enums/validationErrorMessage";
import {ErrorType} from "~/enums/ErrorType";

export default class EmbeddedCollectionValidator<T> extends NavigableValidator<T> {
  defaultMessage = ValidationErrorMessage.MustBePresent;
  defaultType = ErrorType.mustBePresent;
  allChildren: INavigableValidatableModel<T>[] = [];

  protected _validate(model: INavigableValidatableModel<T>): void {
    this.allChildren = this.getAllChildren(model);
    this.allChildren.forEach(child => child.validate());
  }

  constructor(options: Partial<INavigableValidatorOptions<T>>, readonly parentModel: T) {
    super(options);
  }

  set errors(val){}
  get errors() {
    const errors = [];
    if (this.shouldValidate(this.parentModel)) {
      this.allChildren.forEach(c => c.validation.errors.forEach(e => errors.push(e)));
    }
    return errors;
  }

  get results(): ValidationResultValueInterface[] {
    const result = [];
    this.allChildren.forEach(step => {
      return Object.keys(step.validation.results).forEach(key => {
        result.push(step.validation.results[key]);
      });
    });
    return result;
  }

  protected getCollection(model): {[key: string]: any} {
    return model[this.field];
  }

  protected getAllChildren(model) {
    const records: INavigableValidatableModel<T>[] = [];
    const collection = this.getCollection(model);
    for (const id in collection) {
      const record = collection[id];
      if (record.validate) {
        records.push(collection[id]);
      }
    }
    return records;
  }
}